import { render, staticRenderFns } from "./LandlordKYCFormMobile.vue?vue&type=template&id=6e86a91a&"
import script from "./LandlordKYCFormMobile.vue?vue&type=script&lang=js&"
export * from "./LandlordKYCFormMobile.vue?vue&type=script&lang=js&"
import style0 from "./LandlordKYCFormMobile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LandlordKYCFormMobile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports